// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2o4lz","colCheckbox":"styles_colCheckbox__bfkU0"};